import Radio, { RadioChangeEvent } from 'antd/lib/radio'
import styles from './ParameterFeedback.module.less'
import { useCallback } from 'react'
import { LiveFeedbackDetailsType } from 'Types/LiveFeedback.types'

enum ParameterFeedbackOptionType {
    Yes = 'yes',
    No = 'no',
}

type ParameterFeedbackProps = {
    activeDetail: LiveFeedbackDetailsType
    serialNumber: number
    totalCount: number
    onFeedback: (parameterId: string, isAccepted: boolean) => void
    parameterFeedback: Record<string, boolean>
}

export const ParameterFeedback = ({
    activeDetail,
    parameterFeedback,
    serialNumber,
    totalCount,
    onFeedback,
}: ParameterFeedbackProps) => {
    const isAccepted = parameterFeedback[activeDetail.id] ?? undefined

    const getValue = useCallback(() => {
        let value = undefined
        if (isAccepted === true) {
            value = ParameterFeedbackOptionType.Yes
        } else if (isAccepted === false) {
            return ParameterFeedbackOptionType.No
        }
        return value
    }, [isAccepted])

    const handleSelection = useCallback(
        (e: RadioChangeEvent) => {
            onFeedback?.(activeDetail.id, e.target.value === ParameterFeedbackOptionType.Yes)
        },
        [onFeedback, activeDetail.id]
    )

    return (
        <div className={styles['agent-response-feedback-container']}>
            <div className={styles.header}>
                <div className={styles.question}>Is the feedback above helpful and sufficient?</div>
                <div className={styles.counter}>
                    {serialNumber}/{totalCount}
                </div>
            </div>

            <Radio.Group value={getValue()} onChange={handleSelection} className={styles.options}>
                <Radio value={ParameterFeedbackOptionType.Yes} className={styles['radio-yes']}>
                    YES
                </Radio>
                <Radio value={ParameterFeedbackOptionType.No} className={styles['radio-no']}>
                    NO
                </Radio>
            </Radio.Group>
        </div>
    )
}
